var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgArrowBack = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.376718 6.0308C0.444208 5.96003 0.518252 5.90019 0.595344 5.8482L5.79282 0.397852C6.04524 0.132959 6.37613 0.000610267 6.70703 0.000610295C7.03792 0.000610323 7.36863 0.132959 7.62123 0.397852C8.12626 0.927445 8.12626 1.78622 7.62123 2.31562L3.14261 7.01282L7.59871 11.6857C8.10373 12.2156 8.10373 13.0741 7.59871 13.6035C7.09368 14.1331 6.27494 14.1328 5.76992 13.6038L0.595435 8.17783C0.518343 8.12584 0.444299 8.0661 0.377086 7.99523C0.118943 7.72453 -0.00560355 7.36795 0.000212993 7.01292C-0.00588047 6.65808 0.11839 6.3017 0.376718 6.0308Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgArrowBack);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/arrowBack.0795410bf8d2943fa596436e6b8f7114.svg";